import { useContext, useMemo } from 'react';
import { logError } from '@/utils/logHandling';
import {
  AudioActionsContext,
  AudioStateContext,
} from '@/contexts/AudioContext';
import { AudioActions, AudioContextValue } from '@/contexts/AudioContext/types';

/**
 * Actions only. Subscribing to this instead of useAudioContext keeps a
 * component out of the playback re-render loop — the actions object is stable
 * for the lifetime of the provider, so position updates don't reach it.
 */
export const useAudioActions = (): AudioActions => {
  const actions = useContext(AudioActionsContext);

  if (!actions) {
    logError('AudioContext not found error');
    throw new Error('AudioContext not found');
  }

  return actions;
};

export const useAudioContext = (): AudioContextValue => {
  const actions = useAudioActions();
  const context = useContext(AudioStateContext);

  if (!context) {
    logError('AudioContext not found error');
    throw new Error('AudioContext not found');
  }

  return useMemo(() => ({ ...actions, context }), [actions, context]);
};
